module.exports = __webpack_public_path__ + "static/img/echospot2.1f6577a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/echospot2.png
// module id = kpj/
// module chunks = 0